export default __webpack_public_path__ + "static/spanish-title-pix-14e6563fd992039e362128ebf05fd45d.jpg";